/**
 * System-landscape diagram - layout constants (canvas/grid geometry).
 * Shared by the web diagram and the server-side SVG renderer.
 */
export const SYSTEM_LANDSCAPE_LAYOUT = {
    canvasWidth: 900,
    canvasHeight: 530,
    canvasPaddingX: 36,
    headerTop: 18,
    headerHeight: 18,
    headerBottomGap: 12,
    columnGap: 100,
    regularNodeWidth: 176,
    regularNodeHeight: 96,
    compactNodeWidth: 152,
    compactNodeHeight: 84,
    erpNodeWidth: 208,
    erpNodeHeight: 200,
    fitViewPadding: 0.045,
    exportMarginPt: 24,
};
/** Rendered height of an ERP node with no embedded child (matches the `--erp` CSS class). */
export const ERP_NO_EMBED_HEIGHT = 160;
const CONTENT_TOP = SYSTEM_LANDSCAPE_LAYOUT.headerTop +
    SYSTEM_LANDSCAPE_LAYOUT.headerHeight +
    SYSTEM_LANDSCAPE_LAYOUT.headerBottomGap;
const LEFT_COLUMN_X = SYSTEM_LANDSCAPE_LAYOUT.canvasPaddingX;
const CENTER_COLUMN_X = LEFT_COLUMN_X + SYSTEM_LANDSCAPE_LAYOUT.regularNodeWidth + SYSTEM_LANDSCAPE_LAYOUT.columnGap;
const RIGHT_COLUMN_X = CENTER_COLUMN_X + SYSTEM_LANDSCAPE_LAYOUT.erpNodeWidth + SYSTEM_LANDSCAPE_LAYOUT.columnGap;
export const SYSTEM_LANDSCAPE_COLUMN_X = {
    left: LEFT_COLUMN_X,
    center: CENTER_COLUMN_X,
    right: RIGHT_COLUMN_X,
};
const ROW_GAP = 24;
export const SYSTEM_LANDSCAPE_ROW_Y = {
    top: CONTENT_TOP,
    middle: CONTENT_TOP + SYSTEM_LANDSCAPE_LAYOUT.regularNodeHeight + ROW_GAP,
    bottom: CONTENT_TOP +
        SYSTEM_LANDSCAPE_LAYOUT.regularNodeHeight +
        ROW_GAP +
        SYSTEM_LANDSCAPE_LAYOUT.erpNodeHeight +
        ROW_GAP,
};
/** Column-header widths (left/right = regular node, center = ERP node). */
export const SYSTEM_LANDSCAPE_COLUMN_HEADER_WIDTH = {
    left: SYSTEM_LANDSCAPE_LAYOUT.regularNodeWidth,
    center: SYSTEM_LANDSCAPE_LAYOUT.erpNodeWidth,
    right: SYSTEM_LANDSCAPE_LAYOUT.regularNodeWidth,
};
export const SYSTEM_LANDSCAPE_HEADER_GRID_TEMPLATE = `${SYSTEM_LANDSCAPE_LAYOUT.regularNodeWidth}px ${SYSTEM_LANDSCAPE_LAYOUT.erpNodeWidth}px ${SYSTEM_LANDSCAPE_LAYOUT.regularNodeWidth}px`;
export const SYSTEM_LANDSCAPE_VIRTUAL_EXTENT = [
    [0, 0],
    [SYSTEM_LANDSCAPE_LAYOUT.canvasWidth, SYSTEM_LANDSCAPE_LAYOUT.canvasHeight],
];
//# sourceMappingURL=layout.js.map